import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import { connect } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TeamChatView from './TeamChatView';
import Memo from './Memo';
import Icons from '../Common/Icons';

const styles = () =>
	({
		root :
		{
			flexGrow        : 1,
			maxWidth        : 500,
			width           : '100%',
			height          : '100%',
			borderRadius    : '0.5rem',
			boxShadow       : 'none',
			backgroundColor : 'transparent',
			paddingRight    : '1%'
		},
		tabBody : {
			backgroundColor         : 'white',
			height                  : 'calc(100% - 4rem)',
			borderBottomRightRadius : '0.5rem',
			borderBottomLeftRadius  : '0.5rem',
			borderTopRightRadius    : '0.5rem',
			boxShadow               : '2px 2px 4px #aaa'
		},
		memo :
		{
			padding : '2%'
		},
		memoEditTitle :
		{
			textAlign : 'center'
		},
		memoListItemDate :
		{
			width          : '80%',
			borderBottom   : '1px solid #999898',
			color          : '#999898',
			display        : 'flex',
			justifyContent : 'space-between'
		},
		memoEdit :
		{
			width           : '100%',
			height          : '100%',
			backgroundColor : '#fff',
			boxShadow       : '2px 2px 4px #aaa',
			borderRadius    : '0.5rem',
			display         : 'flex',
			flexDirection   : 'column',
			justifyContent  : 'space-between'
		},
		memoEditHeader :
		{
			height               : '1.2rem',
			borderTopRightRadius : '0.5rem',
			borderTopLeftRadius  : '0.5rem',
			display              : 'flex',
			justifyContent       : 'flex-end',
			alignItems           : 'center',
			'& > button'         : {
				padding : '2% 0%'
			}
		},
		memoEditDelete :
		{
			color       : '#E57F00',
			fontSize    : '1.5rem',
			marginTop   : '1.5rem',
			marginRight : '0.5rem'
		},
		memoEditContent :
		{
			padding : '0',
			height  : '100%'
		}
	});

function TabPanel(props)
{
	const {
		children,
		value,
		index,
		classes,
		...other
	} = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			className={classes.tabBody}
			{...other}
		>
			{value === index && (
				children
			)}
		</div>
	);
}

TabPanel.propTypes =
{
	classes  : PropTypes.any.isRequired,
	children : PropTypes.node,
	index    : PropTypes.any.isRequired,
	value    : PropTypes.any.isRequired
};

const theme = createTheme({
	overrides : {
		MuiTabs : {
			root : {
				height    : '4rem',
				minHeight : 0
			},
			indicator : {
				backgroundColor : 'transparent',
				color           : '#9ec317',
				width           : '0'
			}
		},
		MuiTab : {
			root : {
				minWidth             : 80,
				borderTopRightRadius : '0.5rem',
				borderTopLeftRadius  : '0.5rem',
				'&:hover'            : {
					backgroundColor : 'transparent',
					color           : '#9ec317'
				},
				'&$selected' : {
					backgroundColor : 'white',
					color           : '#9ec317',
					boxShadow       : '2px 2px 4px #aaa',
					'&:hover'       : {
						backgroundColor : 'white',
						color           : '#9ec317'
					}
				},
				'@media (min-width: 600px)' : {
					minWidth : 80
				}
			},
			wrapper : {
				fontSize : '0.7rem'
			}
		}
	}
});

const TeamToolView = ({
	room,
	classes,
	style,
	memo,
	tab,
	changeTab
}) =>
{

	return (
		<MuiThemeProvider theme={theme}>
			<Paper square className={classes.root} style={style}>
				<Tabs
					value={tab}
					onChange={changeTab}
					aria-label='icon label tabs'
				>
					<Tab icon={<Icons category={'host'} iconName={'chat'} type={tab === 0 ? 'active' : 'normal'} size={'1.5rem'}/>} label='グループチャット' />
					<Tab icon={<Icons category={'host'} iconName={'memo'} type={tab === 1 ? 'active' : 'normal'} size={'1.5rem'}/>} label='通話メモ' />
				</Tabs>
				<TabPanel value={tab} index={0} classes={classes}>
					<TeamChatView />
				</TabPanel>
				<TabPanel value={tab} index={1} classes={classes}>
					{(memo !== null && !room.memoDialogOpen) &&
						<div className={classes.memoEdit}>
							<div className={classes.memoEditContent}>
								<Memo btnEnabled={[ true, true, true, false, false, true ]}/>
							</div>
						</div>
					}
				</TabPanel>
			</Paper>
		</MuiThemeProvider>
	);
};

TeamToolView.propTypes =
{
	room      : PropTypes.object.isRequired,
	classes   : PropTypes.any.isRequired,
	style     : PropTypes.any,
	memo      : PropTypes.object,
	tab       : PropTypes.string,
	changeTab : PropTypes.func
};

const mapStateToProps = (state) =>
{
	return {
		room : state.room,
		memo : state.room.memo
	};
};

const mapDispatchToProps = () =>
{
	return {
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.room.memo === next.room.memo
			);
		}
	}
)(withStyles(styles)(TeamToolView)));